import React from "react";
import Seo from "@/utils/seo";
import Banner from "@/components/pages/data-hub/banner";
import SurveyData from "@/components/pages/data-hub/survey-data";
import AboutPci from "@/components/pages/data-hub/about-pci";

export default function DataHub() {
  const seo = {
    slug: "/data-hub",
    metaTitle:
      "Data Hub | People’s Courage International",
    metaDescription:
      "The People’s Courage International Data Hub brings data and evidence on informal workers and their climate vulnerability into clear, accessible view.",
  };

  return (
    <>
      <Seo seo={seo} />
      <Banner />
      <SurveyData />
      <AboutPci />
    </>
  );
}
